import styled from "@emotion/styled";
import { Modal } from "antd";
import { useMemo } from "react";
import { Table, Typography, Row, Col } from "antd";
import { CheckCircleTwoTone, ExclamationCircleTwoTone } from "@ant-design/icons";

const CustomModal = styled(Modal)`
        .ant-modal-body {
            padding: 0;
        }
        .ant-modal-content {
            padding: 12px 16px;
            border-radius: 8px !important;
        }
        .ant-modal-header {
            padding: 8px 12px;

            border-bottom: none !important;
        }
        .ant-modal-footer {
            border-top: none !important;
            padding: 16px 0 8px 0;
        }
        .ant-modal-close-icon {
            position: relative;
            top: -2px;
        }
        .ant-modal-title {
            font-weight: 400 !important;
        }
        .ant-btn {
            border-radius: 8px !important;
        }
    `;

const TableContainer = styled.div`
        background: #fafafa;
        border-radius: 8px;
        padding: 8px 0 0 0;
        box-shadow: none;
        margin-bottom: 0;
    `;
const customTableStyle = {
    border: 'none',
    borderRadius: 8,
    background: '#fafafa',
};
const customHeaderStyle = {
    background: '#f5f5f5',
    fontWeight: 600,
    fontSize: 14,
};

const PublishPlanModal = ({
    open,
    setOpen,
    calenderDataObject,
    onPublishPlan,
    confirmLoading,
}: {
    open: boolean;
    setOpen: Function;
    calenderDataObject: any;
    onPublishPlan: Function;
    confirmLoading: boolean;
}) => {
    if (!open) return null;

    const draftPromos = useMemo(() => {
        if (calenderDataObject?.calenderData?.result?.length) {
            return calenderDataObject?.calenderData?.result?.filter(
                (item: any) => item.promoStatus?.toLowerCase() === 'draft',
            );
        }
    }, [calenderDataObject?.calenderData?.result]);

    const plannedPromos = useMemo(() => {
        if (calenderDataObject?.calenderData?.result?.length) {
            return calenderDataObject?.calenderData?.result?.filter((item: any) => {
                return item.is_publishable;
            });
        }
    }, [calenderDataObject?.calenderData?.result]);

    return (
        <CustomModal
            maskClosable={false}
            destroyOnClose
            centered
            open={open}
            width={920}
            title={<div className="flex items-center">{'Publish Plan'}</div>}
            onCancel={() => setOpen(false)}
            onOk={() => onPublishPlan()}
            okButtonProps={{ disabled: !plannedPromos?.length }}
            okText="Publish Now"
            cancelText="Close"
            confirmLoading={confirmLoading}
            style={{ borderRadius: 8 }}
        >
            {/* <div className="mb-3 bg-[#fffbe6] border border-[#ffe58f] rounded px-3 py-2 flex items-center text-[14px]">
                <ExclamationCircleTwoTone twoToneColor="#faad14" className="mr-2" />
                Only promos with 'Planned' status will be published. Draft promos will be skipped.
            </div> */}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Planned Promos */}
                <div>
                    <div className="flex items-center mb-2">
                        <CheckCircleTwoTone twoToneColor="#52c41a" className="mr-2" />
                        <span className="font-semibold">Ready to publish ({plannedPromos?.length || 0})</span>
                    </div>
                    <TableContainer>
                        <Table
                            size="small"
                            showHeader
                            bordered={false}
                            pagination={false}
                            dataSource={
                                plannedPromos?.map((item: any, idx: number) => ({
                                    key: idx,
                                    promoName: item.promo,
                                    status: item.promoStatus,
                                })) || []
                            }
                            scroll={{ y: 300 }}
                            columns={[
                                {
                                    title: <span className="font-semibold text-gray-700">Promo name</span>,
                                    dataIndex: 'promoName',
                                    key: 'promoName',
                                    render: (text: string) => <span>{text}</span>,
                                },
                                {
                                    title: <span className="font-semibold text-gray-700">Status</span>,
                                    dataIndex: 'status',
                                    key: 'status',
                                    render: (text: any) => (
                                        <span className="text-[#9254de] border border-[#d3adf7] rounded px-2 py-1 font-medium bg-[#f9f0ff] inline-block min-w-[60px] text-center break-words">
                                            {text}
                                        </span>
                                    ),
                                },
                            ]}
                            className="custom-table !border-none"
                            rowClassName={() => 'custom-table-row'}
                        />
                    </TableContainer>
                </div>

                {/* Draft Promos */}
                <div>
                    <div className="flex items-center mb-2">
                        <ExclamationCircleTwoTone twoToneColor="#faad14" className="mr-2" />
                        <span className="font-semibold">Will not be published</span>
                    </div>
                    <TableContainer>
                        <Table
                            size="small"
                            showHeader
                            bordered={false}
                            pagination={false}
                            dataSource={
                                draftPromos?.map((item: any, idx: number) => ({
                                    key: idx,
                                    promoName: item.promo,
                                    status: item.promoStatus,
                                })) || []
                            }
                            scroll={{ y: 300 }}
                            columns={[
                                {
                                    title: <span className="font-semibold text-gray-700">Promo name</span>,
                                    dataIndex: 'promoName',
                                    key: 'promoName',
                                    render: (text: string) => <span>{text}</span>,
                                },
                                {
                                    title: <span className="font-semibold text-gray-700">Status</span>,
                                    dataIndex: 'status',
                                    key: 'status',
                                    render: () => (
                                        <span className="text-[#595959] border border-[#d9d9d9] rounded px-2 py-1 font-medium bg-[#fafafa] inline-block min-w-[60px] text-center break-words">
                                            Draft
                                        </span>
                                    ),
                                    width: 90,
                                },
                            ]}
                            className="custom-table !border-none"
                            rowClassName={() => 'custom-table-row'}
                        />
                    </TableContainer>
                </div>
            </div>
        </CustomModal>
    );
};

export default PublishPlanModal;